import styled from "styled-components";
import { Section } from "components/common";
const PaperSection = styled(Section)`
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
`;
export default PaperSection;
